import React, {useCallback, useContext, useMemo} from 'react';

interface Messages {
    [key: string]: string;
}

interface MessageOptions {
    [key: string]: string | number;
}

interface MessageContextProps {
    messages: Messages;
    getText: (key: string, options?: MessageOptions) => string | null;
}

interface MessageProviderProps {
    messages: Messages;
    children: React.ReactNode;
}

export const MessageContext = React.createContext<MessageContextProps>({
    messages: {},
    getText: () => `[no context]`
});

export const MessageContextProvider = ({messages: messagesToBe, children}: MessageProviderProps) => {
    const {messages: messagesThatAre} = useContext(MessageContext);

    const messages = useMemo(() => ({...messagesThatAre, ...messagesToBe}), [messagesThatAre, messagesToBe]);
    const getText = useCallback((key) => messages[key] || `[no key: <${key}>]`, [messages]);

    const value = useMemo(() => ({messages, getText}), [messages, getText]);

    return <MessageContext.Provider value={value}>{children}</MessageContext.Provider>;
};
